import { put, takeEvery, takeLatest } from 'redux-saga/effects'
import call from '../call'
import { DATACENTER } from '../actionTypes'
import { safeJsonParse, changeLngLat } from '../../utils/util'
import { resourceMap, GUANGZHOU_YANSHI_ID } from '../../utils/consts'

import {
  getBasicInfo as getBasicInfoService,
  getMapInfo as getMapInfoService,
  getStatisticInfo as getStatisticInfoService,
  getOrderAndBikeTrend as getOrderAndBikeTrendService,
  getCityInfo as getCityInfoService,
  getBikeInfo as getBikeInfoService,
  getParkingPosition as getParkingPositionService,
  getOperationPosition as getOperationPositionService,
  getHeatMap as getHeatMapService,
  getLatestOrder as getLatestOrderService,
  getAreaInfo as getAreaInfoService,
  getParkingPointAlarmList as getParkingPointAlarmListService,
  getBikeLatestOrderList as getBikeLatestOrderListService,
  getUserReserveWorkOrder as getUserReserveWorkOrderService,
  getUserFeedbackWorkOrder as getUserFeedbackWorkOrderService,
} from '../service/dataCenter'

const dataCenterMap = 'DATACENTERMAP'

export function* getBasicInfo(payload: Payload) {
  const data: ResponseData = yield call(getBasicInfoService, payload)
  if (data && data.code === 0) {
    yield put({
      type: DATACENTER.UPDATE_STATE,
      payload: { basicInfo: data.data },
    })
  }
}

export function* getMapInfo(payload: Payload) {
  const data: ResponseData = yield call(getMapInfoService, payload)
  if (data && data.code === 0) {
    yield put({
      type: DATACENTER.UPDATE_STATE,
      payload: { mapInfo: data.data },
    })
  }
}

export function* getStatisticInfo(payload: Payload) {
  const data: ResponseData = yield call(getStatisticInfoService, payload)
  if (data && data.code === 0) {
    yield put({
      type: DATACENTER.UPDATE_STATE,
      payload: { statisticInfo: data.data },
    })
  }
  payload.cb && payload.cb()
}

export function* getOrderAndBikeTrend(payload: Payload) {
  const data: ResponseData = yield call(getOrderAndBikeTrendService, payload)
  if (data && data.code === 0) {
    yield put({
      type: DATACENTER.UPDATE_STATE,
      payload: { orderBikeTrendInfo: data.data },
    })
  }
  payload.cb && payload.cb()
}

export function* getCityInfo(payload: Payload) {
  const data: ResponseData = yield call(getCityInfoService, payload, { loadingName: dataCenterMap })
  if (data && data.code === 0) {
    yield put({
      type: DATACENTER.UPDATE_STATE,
      payload: { cityInfo: data.data },
    })
  }
}

export function* getBikeInfo(payload: Payload) {
  const data: ResponseData = yield call(getBikeInfoService, payload, { loadingName: dataCenterMap })
  if (data && data.code === 0) {
    const datas = data.data || []
    const [bikeLocations = [], spockLocations = []] = [
      datas[0]?.bikeLocationInfo?.map((info: any) => ({
        lat: +info.bikeReportLngLat[1],
        lng: +info.bikeReportLngLat[0],
        useIot: payload.payload?.entityCode === GUANGZHOU_YANSHI_ID,
        ...info,
      })),
      datas[1]?.bikeLocationInfo?.map((info: any) => ({
        lat: +info.bikeReportLngLat[1],
        lng: +info.bikeReportLngLat[0],
        useIot: payload.payload?.entityCode === GUANGZHOU_YANSHI_ID,
        ...info,
      })),
    ]
    yield put({
      type: DATACENTER.UPDATE_STATE,
      payload: { bikeInfo: { bikeLocations, spockLocations } },
    })
    // 使用bikeId搜索
    if (payload.payload?.bikeId && bikeLocations.length && payload.cb) {
      payload.cb(bikeLocations[0])
    }
  }
}

export function* getParkingPosition(payload: Payload) {
  const data: ResponseData = yield call(getParkingPositionService, payload, {
    loadingName: dataCenterMap,
  })
  if (data && data.code === 0) {
    const datas = data.data || []
    const [parkingPosition = [], noParkingPosition = [], operationArea = []] = [
      datas[0]?.parkingLocationInfo,
      datas[1]?.parkingLocationInfo,
      datas[2]?.parkingLocationInfo,
    ]
    const coordinates = [parkingPosition, noParkingPosition, operationArea].map(position => {
      return position.map((item: any) => {
        const region = safeJsonParse(item['region'])
        return {
          region: changeLngLat(region.coordinates),
          center: item.center,
          businessType: item.businessType,
          parkingPointId: item.parkingPointId,
          parkingPointName: item.parkingPointName,
          parkingType: item.parkingType,
        }
      })
    })
    yield put({
      type: DATACENTER.UPDATE_STATE,
      payload: { parkingCoordinates: coordinates },
    })
  }
}

export function* getOperationPosition(payload: Payload) {
  const data: ResponseData = yield call(getOperationPositionService, payload, {
    loadingName: dataCenterMap,
  })
  if (data && data.code === 0) {
    const datas = data.data || []
    const [operatorPosition = [], operatorCarPosition = []] = [
      datas[0]?.opsLocationInfo,
      datas[1]?.opsLocationInfo,
    ]
    yield put({
      type: DATACENTER.UPDATE_STATE,
      payload: { operationPosition: { operatorPosition, operatorCarPosition } },
    })
  }
}

export function* getHeatMap(payload: Payload) {
  const data: ResponseData = yield call(getHeatMapService, payload, { loadingName: dataCenterMap })
  if (data && data.code === 0) {
    const datas = data.data || []
    const [bikeLocations = [], spockLocations = []] = [
      datas[0]?.bikeLocationInfo?.map((info: any) => ({
        lat: +info.bikeReportLngLat[1],
        lng: +info.bikeReportLngLat[0],
        ...info,
      })),
      datas[1]?.bikeLocationInfo?.map((info: any) => ({
        lat: +info.bikeReportLngLat[1],
        lng: +info.bikeReportLngLat[0],
        ...info,
      })),
    ]
    // const coordinates = [parkingPosition, noParkingPosition].map(position => {
    //   return position.map(item => {
    //     let region = safeJsonParse(item['region'])
    //     return { region: changeLngLat(region.coordinates), center: item.center }
    //   })
    // })
    yield put({
      type: DATACENTER.UPDATE_STATE,
      payload: { heatMap: { bikeLocations, spockLocations } },
    })
  }
}

export function* getLatestOrder(payload: Payload) {
  const data: ResponseData = yield call(getLatestOrderService, payload)
  if (data && data.code === 0) {
    const { resourceId } = payload.payload || {}
    if (resourceId === resourceMap.dataCenter.orderStateRoll) {
      yield put({
        type: DATACENTER.UPDATE_STATE,
        payload: { scrollOrder: data.data },
      })
    } else if (resourceId === resourceMap.dataCenter.orderImgShow) {
      yield put({
        type: DATACENTER.UPDATE_STATE,
        payload: { finishOrder: data.data },
      })
    }
  }
}

export function* getAreaInfo(payload: Payload) {
  const data: ResponseData = yield call(getAreaInfoService, payload, { loadingName: dataCenterMap })
  if (data && data.code === 0) {
    const { center = [], region = {} } = data.data || {}
    const areaInfo = { region: changeLngLat(region?.coordinates), center }
    yield put({
      type: DATACENTER.UPDATE_STATE,
      payload: { areaInfo },
    })
  }
}

export function* getParkingPointAlarmList(payload: Payload) {
  const data: ResponseData = yield call(getParkingPointAlarmListService, payload)
  if (data && data.code === 0) {
    yield put({
      type: DATACENTER.UPDATE_STATE,
      payload: { parkingPointAlarmList: data.data },
    })
  }
}

export function* getBikeLatestOrderList(payload: Payload) {
  const data: ResponseData = yield call(getBikeLatestOrderListService, payload)
  if (data && data.code === 0 && data.data) {
    yield put({
      type: DATACENTER.UPDATE_STATE,
      payload: { bikeLatestOrderList: data.data, fullScreen: true, showBikeOrderList: true },
    })
  }
}
export function* getUserReserveWorkOrder(payload: Payload) {
  const data: ResponseData = yield call(getUserReserveWorkOrderService, payload)
  if (data && data.code === 0 && data.data) {
    yield put({
      type: DATACENTER.UPDATE_STATE,
      payload: { reserveWorkOrder: data.data },
    })
  }
}

export function* getUserFeedbackWorkOrder(payload: Payload) {
  const data: ResponseData = yield call(getUserFeedbackWorkOrderService, payload)
  if (data && data.code === 0 && data.data) {
    yield put({
      type: DATACENTER.UPDATE_STATE,
      payload: { feedBackWorkOrder: data.data },
    })
  }
}

export default function* root() {
  yield takeLatest(DATACENTER.GET_BASIC_INFO, getBasicInfo)
  yield takeLatest(DATACENTER.GET_MAP_INFO, getMapInfo)
  yield takeLatest(DATACENTER.GET_STATISTIC_INFO, getStatisticInfo)
  yield takeLatest(DATACENTER.GET_ORDER_AND_BIKE_TREND, getOrderAndBikeTrend)
  yield takeLatest(DATACENTER.GET_CITY_INFO, getCityInfo)
  yield takeLatest(DATACENTER.GET_BIKE_INFO, getBikeInfo)
  yield takeLatest(DATACENTER.GET_PARKING_POSITION, getParkingPosition)
  yield takeLatest(DATACENTER.GET_OPERATION_POSITION, getOperationPosition)
  yield takeLatest(DATACENTER.GET_HEAT_MAP, getHeatMap)
  yield takeEvery(DATACENTER.GET_LATEST_ORDER, getLatestOrder)
  yield takeEvery(DATACENTER.GET_AREA_INFO, getAreaInfo)
  yield takeEvery(DATACENTER.GET_PARKING_POINT_ALARM_LIST, getParkingPointAlarmList)
  yield takeLatest(DATACENTER.GET_BIKE_LATEST_ORDER_LIST, getBikeLatestOrderList)
  yield takeLatest(DATACENTER.GET_USER_RESERVE_WORD_ORDER, getUserReserveWorkOrder)
  yield takeLatest(DATACENTER.GET_USER_FEEDBACK_WORD_ORDER, getUserFeedbackWorkOrder)
}
